module.exports = __webpack_public_path__ + "static/media/Library_2.31b7fe42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_2.png
// module id = 1289
// module chunks = 3